import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
 standalone: false,
  name: 'mxDateFormat',
  pure: true,
})
export class MxDateFormatPipe implements PipeTransform {
  constructor() {}
  transform(value: string, format: string): any {
    return moment(value).isValid()
      ? moment(value).utcOffset(0).year() !== 1
        ? moment(value).utcOffset(0).format(format)
        : ''
      : '';
  }
}

